import React, { useEffect, useState } from "react"
import { Card, CardBody, CardFooter, Col, Row, Table } from "reactstrap"
import { connect } from "react-redux"
import { SaveButton } from "components/Buttons"
import { withRouter } from "react-router-dom"

const UsersCard = ({
  eventInviteList,
  handleViewMore,
  history,
  vendorId,
  eventId,
}) => {
  return (
    <Card className="mini-stats-wid flex-grow-1">
      <CardBody className="pb-0">
        <Row>
          <Col>
            <h5>Users</h5>
          </Col>
        </Row>
        <Row>
          {!!eventInviteList.data && eventInviteList?.data?.length > 0 ? (
            <div className="table-responsive p-0">
              <Table className="align-middle table-nowrap">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Access Type</th>
                  </tr>
                </thead>
                <tbody>
                  {eventInviteList?.data?.slice(0, 3)?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div>
                          <p className="font-size-14 mb-1">
                            {item?.first_name
                              ? item?.first_name
                              : "" + " " + item?.last_name
                              ? item?.last_name
                              : " "}
                          </p>
                        </div>
                      </td>

                      <td>
                        <div>
                          <p className="font-size-14 mb-1">
                            {item?.user_status}
                          </p>
                        </div>
                      </td>

                      <td>
                        <div>
                          <p className="font-size-14 mb-1">
                            {item?.rsvp_string_type}
                          </p>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <p>No data to display</p>
          )}
        </Row>
      </CardBody>
      <CardFooter style={{ background: "white" }} className="pt-0">
        <Row className="d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color={"primary"}
              size="sm"
              content="View More"
              onClick={() => {
                history.push({
                  pathname: `/events/${vendorId}/${eventId}`,
                  state: { tab: 4 },
                })
              }}
            />
          </Col>
        </Row>
      </CardFooter>
    </Card>
  )
}

const mapStateToProps = state => ({
  eventInviteList: state.experiences.eventInviteList,
  vendorId: state.Login.vendorId,
})

export default connect(mapStateToProps)(withRouter(UsersCard))
